<bn-loading-overlay></bn-loading-overlay>
<h5>Patrimônio Líquido do Fundo</h5>
<div class="container">
  <form [formGroup]="pesquisaForm" class="mt-3 mx-auto" (keyup.enter)="focusableSubmit.click()">
    <div class="row">
      <div class="col">
        <h3>Filtros de pesquisa</h3>
      </div>
      <div *ngIf="podeCadastrar" class="col-auto">
        <button class="btn btn-primary no-margin" type="button" [routerLink]="['/habilitacao/patrimonio-liquido/novo']"
          ngbTooltip="Selecione esta opção para incluir um Patrimônio Líquido."><i class="fa fa-file-signature">
          </i> Cadastrar PL
        </button>
      </div>
      <div class="col-auto">
        <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
      </div>
      <div class="col-auto">
        <button #focusableSubmit type="button" class="btn btn-success no-margin" (keydown.enter)="buscar(false)"
          (click)="buscar(false)" [disabled]="!pesquisaForm.valid">Pesquisar
        </button>
      </div>
    </div>
    <div class="row mt-4">
      <div class="bn-form-group col-md-6">
        <label class="form-label" for="dataBase" >Data Base:</label>
        <input type="text" class="form-control" bnMask="MESANO" name="dataBase" idInput="dataBase"
          formControlName="dataBase" [placeholder]=placeHolderDataBase>
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="dataRegistroInicial">Data registro inicial:</label>
        <bn-datepicker name="dataRegistroInicial" idInput="dataRegistroInicial" formControlName="dataRegistroInicial"
          ngDefaultControl>
        </bn-datepicker>
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="dataRegistroFinal">Data registro final:</label>
        <bn-datepicker name="dataRegistroFinal" idInput="dataRegistroFinal" formControlName="dataRegistroFinal"
          ngDefaultControl>
        </bn-datepicker>
      </div>
    </div>
  </form>
</div>

<app-patrimonio-liquido-listagem
  [patrimoniosLiquidos]="patrimonioLiquidos"
  [atributosPaginacao]="atributosPaginacaoComponenteListagem"
  [podeCadastrar]="podeCadastrar"
  [dataHoraResultado]="dataHoraResultado"
  [msgSemResultado]="msgSemResultado"
  (aoMudarPagina)="mudancaPagina($event)"
  (exportarPLs)="exportar($event)"
></app-patrimonio-liquido-listagem>
